module.exports = __webpack_public_path__ + "img/load.bdff5121.gif";